import React from 'react';
import type { BCPSectionConfig } from './bcpFieldConfig';

export const REGULATION_SECTIONS: BCPSectionConfig[] = [
  {
    id: 'basic_policy',
    title: '1. 基本方針',
    fields: [
      {
        id: 'purpose',
        label: '1-1 規程の目的',
        type: 'textarea',
        minHeight: 'medium',
        placeholder:
          '【規程の必要性】\n当社は医療関連、生活関連、自動車関連の各分野の製品の生産工程に欠かすことのできない重要な製品を供給しているため、大規模地震をはじめとする様々な災害や危機事象発生時において、製品の安定供給という社会的責任を果たすことが必要。\n\n【基本方針】\n①従業員とその家族の安全を守る\n②緊急事態発生後も、現在の事業規模を維持し、従業員の雇用を守る\n③事業の早期再開、もしくは、復旧状況の情報を細やかに提供することにより、顧客の信用を守る\n④帰宅困難者や地域住民を支援することにより、地域社会に貢献する',
        aiConsult: true,
        required: true,
      },
      {
        id: 'revision_policy',
        label: '1-2 運用・改訂の方針',
        type: 'textarea',
        minHeight: 'small',
        placeholder:
          '本規程は、毎年 10月 に定期見直しを実施し、結果を当年度 12月末 までに改訂へ反映する。見直しは事業計画の策定・更新時期と連動して行う。',
        defaultValue:
          '本規程は、毎年 10月 に定期見直しを実施し、結果を当年度 12月末 までに改訂へ反映する。見直しは事業計画の策定・更新時期と連動して行う。',
        aiConsult: true,
        highlightPlaceholders: true,
      },
    ],
  },
  {
    id: 'bcp_goals',
    title: '2. BCP目標の設定',
    fields: [
      {
        id: 'important_business',
        label: '2-1 BCP目標',
        type: 'textarea',
        minHeight: 'medium',
        placeholder: '【重要事業1：{事業名}】\n目標復旧時間（RTO）：\n\n【重要事業2：{事業名}】\n目標復旧時間（RTO）：',
        aiConsult: true,
        required: true,
      },
      {
        id: 'recovery_strategy',
        label: '2-2 BCP目標の達成戦略',
        type: 'textarea',
        minHeight: 'medium',
        placeholder: '【共通】\n・目標復旧時間内に現地復旧が可能な場合は、現地復旧が原則（現地復旧戦略）\n・目標復旧時間内に現地復旧が困難な場合、また、当社のみが被災している状況下では、現地復旧以外の以下戦略を遂行\n\n重要事業1：{事業名}\n・\n・\n・\n・\n\n重要事業2：{事業名}\n・\n・\n・\n・',
        aiConsult: true,
      },
      {
        id: 'emergency_headquarters',
        label: '2-3 緊急対策本部の設置、緊急時の体制',
        type: 'textarea',
        minHeight: 'medium',
        placeholder: [
          '【BCP発動基準】',
          '危機事象の顕在化により、通常のオペレーションでは目標復旧時間内での復旧が困難となる可能性が発生した場合。',
          '但し、震度6弱以上の地震が発生した場合は自動発動とする。',
          '',
          '【緊急対策本部の設置場所】',
          '第一順位：｛拠点名／部屋名を入力｝',
          '第二順位：｛拠点名／部屋名を入力｝',
          '第三順位：｛拠点名／部屋名を入力｝',
          '',
          '【BCP発動時の体制】',
          '■対策本部',
          '本部長：{役職を入力}',
          '本部長代行',
          '　第一順位：{役職を入力}',
          '　第二順位：{役職を入力}',
          '　第三順位：{役職を入力}',
          '[役割]',
          '全体統括',
          '',
          '■事務局',
          '事務局長：｛役職を入力｝',
          '[役割]',
          '災害情報、社会インフラ被害状況、業界情報等の収集、各チーム収集情報のとりまとめ、社内外への情報発信と統制：{部署を入力}',
          '',
          '■初動対応チーム',
          'チーム長：｛役職を入力｝',
          '[役割]',
          '安否情報の集約：｛部署を入力｝',
          '建物・インフラ・ITの被害防止・軽減／安全確保：｛部署を入力｝',
          '救護所運営・負傷者搬送・警備：｛部署を入力｝',
          '帰宅・出社計画、滞留者対応：｛部署を入力｝',
          '',
          '■復旧対応チーム',
          'チーム長：｛役職を入力｝',
          '[役割]',
          '参集可能状況の把握と要員手配：｛部署を入力｝',
          '建物／インフラ設備の現状把握と復旧手配：｛部署を入力｝',
          'システム・ネットワークの現状把握と復旧手配：｛部署を入力｝',
          '資金繰り影響把握と対外支払の遂行：｛部署を入力｝',
          '顧客・競合の状況把握と顧客対応：｛部署を入力｝',
          'ステークホルダー（仕入先・金融機関・行政 等）の状況把握と復旧手配：｛部署を入力｝',
        ].join('\n'),
        defaultValue: [
          '【BCP発動基準】',
          '危機事象の顕在化により、通常のオペレーションでは目標復旧時間内での復旧が困難となる可能性が発生した場合。',
          '但し、震度6弱以上の地震が発生した場合は自動発動とする。',
          '',
          '【緊急対策本部の設置場所】',
          '第一順位：｛拠点名／部屋名を入力｝',
          '第二順位：｛拠点名／部屋名を入力｝',
          '第三順位：｛拠点名／部屋名を入力｝',
          '',
          '【BCP発動時の体制】',
          '■対策本部',
          '本部長：{役職を入力}',
          '本部長代行',
          '　第一順位：{役職を入力}',
          '　第二順位：{役職を入力}',
          '　第三順位：{役職を入力}',
          '[役割]',
          '全体統括',
          '',
          '■事務局',
          '事務局長：｛役職を入力｝',
          '[役割]',
          '災害情報、社会インフラ被害状況、業界情報等の収集、各チーム収集情報のとりまとめ、社内外への情報発信と統制：{部署を入力}',
          '',
          '■初動対応チーム',
          'チーム長：｛役職を入力｝',
          '[役割]',
          '安否情報の集約：｛部署を入力｝',
          '建物・インフラ・ITの被害防止・軽減／安全確保：｛部署を入力｝',
          '救護所運営・負傷者搬送・警備：｛部署を入力｝',
          '帰宅・出社計画、滞留者対応：｛部署を入力｝',
          '',
          '■復旧対応チーム',
          'チーム長：｛役職を入力｝',
          '[役割]',
          '参集可能状況の把握と要員手配：｛部署を入力｝',
          '建物／インフラ設備の現状把握と復旧手配：｛部署を入力｝',
          'システム・ネットワークの現状把握と復旧手配：｛部署を入力｝',
          '資金繰り影響把握と対外支払の遂行：｛部署を入力｝',
          '顧客・競合の状況把握と顧客対応：｛部署を入力｝',
          'ステークホルダー（仕入先・金融機関・行政 等）の状況把握と復旧手配：｛部署を入力｝',
        ].join('\n'),
        aiConsult: true,
        highlightPlaceholders: true,
      },
    ],
  },
  {
    id: 'normal_operations',
    title: '3. 平常時の取り組み',
    fields: [
      {
        id: 'risk_minimization',
        label: '3-1 リスクの最小化',
        type: 'textarea',
        minHeight: 'small',
        placeholder:
          '当社は、事業中断リスクを最小化するため、①設備の定期点検と故障予防対策、②情報セキュリティ対策、③取引先・外部関係者との契約内容について定期的に見直しを実施する（毎年4月）。各対策の責任者・周期・記録方法を定め、点検・訓練・監査結果を速やかに是正し、BCPへ反映する。',
        defaultValue:
          '当社は、事業中断リスクを最小化するため、①設備の定期点検と故障予防対策、②情報セキュリティ対策、③取引先・外部関係者との契約内容について定期的に見直しを実施する（毎年4月）。各対策の責任者・周期・記録方法を定め、点検・訓練・監査結果を速やかに是正し、BCPへ反映する。',
        aiConsult: true,
      },
      {
        id: 'bcm_promotion',
        label: '3-2 BCPの定付・管理、BCM（事業継続マネジメント）の推進体制',
        type: 'textarea',
        minHeight: 'medium',
        placeholder: [
          '【BCM推進体制（平常時）】',
          'BCM推進主管部門：{部門／部署を入力}',
          'BCM推進のため、社長を責任者とする「BCM推進委員会」を定期的に開催する。',
          '',
          '【BCM推進主管部門の実施事項】',
          'Ａ．文書管理',
          '・「初動対応俯瞰表」、「手順書」を作成し、適宜更新する。',
          '',
          'B ．教育・訓練',
          '・訓練計画を別に定め、定期的に実施する。',
          '・全社および関係部門の教育・訓練結果をとりまとめ、「BCM推進委員会」に報告し、実施結果を次回の教育・訓練やBCPに反映させる。',
          '',
          'Ｃ．点検・評価',
          '・BCPの軽微な誤りや古くなった内容の更新等を定期的に実施する。',
          '・BCPやBCMの有効性の評価を定期的に実施する。',
          '・点検・評価結果を定期的にとりまとめ「BCM推進委員会」に報告する。',
          '',
          'Ｄ．是正・改善',
          '・訓練や、点検・評価等で抽出された事項を早急に是正・改善する。経営判断が必要な事項については、「BCM推進委員会」の判断をあおぐ。',
          '・進捗を定期的にとりまとめ「BCM推進委員会」に報告する。',
        ].join('\n'),
        defaultValue: [
          '【BCM推進体制（平常時）】',
          'BCM推進主管部門：{部門／部署を入力}',
          'BCM推進のため、社長を責任者とする「BCM推進委員会」を定期的に開催する。',
          '',
          '【BCM推進主管部門の実施事項】',
          'Ａ．文書管理',
          '・「初動対応俯瞰表」、「手順書」を作成し、適宜更新する。',
          '',
          'B ．教育・訓練',
          '・訓練計画を別に定め、定期的に実施する。',
          '・全社および関係部門の教育・訓練結果をとりまとめ、「BCM推進委員会」に報告し、実施結果を次回の教育・訓練やBCPに反映させる。',
          '',
          'Ｃ．点検・評価',
          '・BCPの軽微な誤りや古くなった内容の更新等を定期的に実施する。',
          '・BCPやBCMの有効性の評価を定期的に実施する。',
          '・点検・評価結果を定期的にとりまとめ「BCM推進委員会」に報告する。',
          '',
          'Ｄ．是正・改善',
          '・訓練や、点検・評価等で抽出された事項を早急に是正・改善する。経営判断が必要な事項については、「BCM推進委員会」の判断をあおぐ。',
          '・進捗を定期的にとりまとめ「BCM推進委員会」に報告する。',
        ].join('\n'),
        aiConsult: true,
        highlightPlaceholders: true,
      },
      {
        id: 'employee_education',
        label: '3-3 従業員教育',
        type: 'textarea',
        minHeight: 'small',
        placeholder:
          '・本規程の内容を全従業員に浸透させるため、年1回以上の研修を実施する。\n・災害発生を想定した訓練を年1回行い、安否確認や初動対応を確認する。\n・BCPの概要版等を社内共有フォルダや掲示板に常時掲載する。\n・受講状況や訓練結果は記録し、必要に応じて改善に活用する。',
        defaultValue:
          '・本規程の内容を全従業員に浸透させるため、年1回以上の研修を実施する。\n・災害発生を想定した訓練を年1回行い、安否確認や初動対応を確認する。\n・BCPの概要版等を社内共有フォルダや掲示板に常時掲載する。\n・受講状況や訓練結果は記録し、必要に応じて改善に活用する。',
        aiConsult: true,
      },
    ],
  },
];

export type RegulationFieldId =
  (typeof REGULATION_SECTIONS)[number]['fields'][number]['id'];
